import { IconAlbums, IconList } from '@/components/icons';

export type TermSheetView = 'list' | 'flashcards';

export function TermSheetViewToggle({
  view,
  onChange,
}: {
  view: TermSheetView;
  onChange: (view: TermSheetView) => void;
}) {
  return (
    <div className="flex items-center gap-1.5">
      <ToggleButton label="List view" active={view === 'list'} onClick={() => onChange('list')}>
        <IconList size={18} strokeWidth={2} />
      </ToggleButton>
      <ToggleButton
        label="Flashcard view"
        active={view === 'flashcards'}
        onClick={() => onChange('flashcards')}
      >
        <IconAlbums size={18} strokeWidth={2} />
      </ToggleButton>
    </div>
  );
}

function ToggleButton({
  label,
  active,
  onClick,
  children,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={active}
      onClick={onClick}
      className={`grid h-8 w-8 place-items-center rounded-lg ${
        active ? 'bg-[#399918] text-white' : 'bg-[#E0E0E0] text-[#9B9B9B]'
      }`}
    >
      {children}
    </button>
  );
}
